import React from 'react'

import styled from 'styled-components'

import logoUrl from '../assets/icons/logo.svg'

type AuthStateProps = {
    isError: boolean
    message: string
    onRetry: () => void
}

const Wrapper = styled.section`
    display: grid;
    place-items: center;
    min-height: 100vh;
    padding: 20px;
    background: linear-gradient(180deg, #fcfcfc 0%, #ffffff 64%);
`

const Card = styled.div`
    width: 100%;
    max-width: 280px;
    padding: 28px 22px;
    border-radius: ${({ theme }) => theme.radii.xl};
    background: #fff;
    box-shadow: ${({ theme }) => theme.shadows.auth};
    text-align: center;
`

const Brand = styled.div`
    display: grid;
    place-items: center;
    width: 52px;
    height: 52px;
    margin: 0 auto 18px;
`

const BrandLogo = styled.img`
    display: block;
    width: 52px;
    height: 52px;
`

const Title = styled.h2`
    margin: 0 0 10px;
    color: #444;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.03em;
`

const Message = styled.p`
    margin: 0;
    color: #8f8f8f;
    font-size: 14px;
    line-height: 1.45;
`

const RetryButton = styled.button`
    min-width: 120px;
    min-height: 40px;
    margin-top: 18px;
    padding: 0 16px;
    border-radius: ${({ theme }) => theme.radii.sm};
    background: ${({ theme }) => theme.colors.purple};
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
`

export function AuthState({ isError, message, onRetry }: AuthStateProps) {
    return (
        <Wrapper>
            <Card>
                <Brand aria-hidden="true">
                    <BrandLogo src={logoUrl} alt="" />
                </Brand>
                <Title>Connecting to Yoffix rooms</Title>
                <Message>{message}</Message>
                {isError ? (
                    <RetryButton type="button" onClick={onRetry}>
                        Try again
                    </RetryButton>
                ) : null}
            </Card>
        </Wrapper>
    )
}
